import type { RootState } from '../store';

/**
 * Read the sidebar layout slice.
 *
 * A PLAIN selector, deliberately not `createSelector`. Memoizing here was not
 * just useless but actively counterproductive: the result function returned its
 * input unchanged, so reselect emitted an identity-function warning and every
 * store update paid the memoization bookkeeping for a value that is already a
 * stable slice reference. Redux guarantees `state.sidebarLayout` keeps the same
 * identity until the slice's own reducers change it, which is exactly the
 * referential stability `useSelector` needs to skip a re-render.
 *
 * Reach for `createSelector` here only if a future caller needs *derived* data
 * (a filtered list, a computed shape) — that is, when the result function does
 * real work and would otherwise allocate a new object on every call.
 */
export const selectSidebarLayout = (state: RootState) => state.sidebarLayout;
